import feature from 'vue-feature-toggle';
import textHelper from '@/core/mixins/textHelper';


export default {
  methods: {
    setProgressColor(progress) {
      return progress < 100 ? 'bg-success pulse' : 'bg-gray';
    },
    getStatusColor(status) {
      return new Map([
        ['live', 'state-success pulse'],
        ['pending', 'state-secondary'],
        ['paused', 'state-danger'],
        ['dormant', 'state-blue'],
        ['review', 'state-warning'],
        ['ended', 'state-dark'],
      ]).get(this.getColumnState(status).toLocaleLowerCase()) || 'state-gray';
    },
    getColumnState(data) {
      const item = data.item ? data.item : data;
      const today = new Date();

      if (item.startDate) {
        const startDate = new Date(item.startDate);
        if (item.state === 'LIVE' && startDate > today) {
          return 'Pending';
        }
      }
      return textHelper.methods.capitalize(item.state);
    },
    updateCampaignState(item, state, isSelfServiceDashboard) {
      const campaignId = item.campaigns ? item.campaigns[0].id : item.id;
      this.isBusy = true;
      this.SET_CAMPAIGN_STATE({
        advertiserId: item.advertiserId,
        campaignId,
        state,
        ...(isSelfServiceDashboard !== null && isSelfServiceDashboard !== undefined && { isSelfServiceDashboard }),
      })
        .then((response) => {
          item.state = response.state;
          this.isBusy = false;
          this.SET_GLOBAL_MESSAGE({
            message: `Campaign was set to ${state}`,
            type: 'info',
          });
          this.refreshTable();
        });
    },
    getAvatarInitials(accountManagerUserId) {
      return this.accountManagersMap.get(accountManagerUserId)?.initials || 'UN';
    },
    getAvatarClass(accountManagerUserId) {
      return `avatar-${this.accountManagersMap.get(accountManagerUserId)?.avatarColour
      || process.env.VUE_APP_AVATAR_DEFAULT_COLOUR}`;
    },
    getStatusIcon(data) {
      return this.getColumnState(data) === 'Pending' ? 'status-icon status-pending' : 'status-icon';
    },
    canEdit(item) {
      return ['LIVE', 'REVIEW', 'PAUSED', 'DORMANT'].includes(item.state) && feature.isVisible('CAMPAIGN_EDIT');
    },
    isDraftState(item) {
      return item.state === 'DRAFT';
    },
    isEndedState(item) {
      return item.state === 'ENDED';
    },
    getBudgetSpentPercentage(budgetRemaining) {
      const budgetPercentage = 100 - budgetRemaining;

      if (budgetPercentage < 0) {
        return 0;
      }
      return budgetPercentage < 0 && budgetPercentage > 100 ? 0 : budgetPercentage;
    },
    formattedMoneyAmount(item) {
      const currencySet = this.currencies.find(
        (currency) => currency.id === item.currencyId,
      );
      if (typeof currencySet === 'undefined') return item.budget || 0;
      const currencySymbol = this.currencyMap[currencySet.code];
      return this.getFormattedMoneyAmount(
        item.budget,
        currencySymbol,
      );
    },
    async assignRowDetailsColumnsWidth() {
      await this.$nextTick();
      if (Object.keys(this.$refs).length) {
        const rootElement = document.querySelector(':root');
        rootElement.style.setProperty('--row-details-expand-width', `${this.$refs['expand-column']?.clientWidth}px`);
        rootElement.style.setProperty('--row-details-campaign-name-width', `${this.$refs['campaign-name-column']?.clientWidth}px`);
        rootElement.style.setProperty('--row-details-state-width', `${this.$refs['state-column']?.clientWidth}px`);
        rootElement.style.setProperty('--row-details-start-date-width', `${this.$refs['start-date-column']?.clientWidth}px`);
        rootElement.style.setProperty('--row-details-end-date-width', `${this.$refs['end-date-column']?.clientWidth}px`);
        rootElement.style.setProperty('--row-details-budget-width', `${this.$refs['budget-column']?.clientWidth}px`);
        rootElement.style.setProperty('--row-details-impressions-width', `${this.$refs['impressions-column']?.clientWidth}px`);
        rootElement.style.setProperty('--row-details-clicks-width', `${this.$refs['clicks-column']?.clientWidth}px`);
        rootElement.style.setProperty('--row-details-ctr-width', `${this.$refs['ctr-column']?.clientWidth}px`);
        rootElement.style.setProperty('--row-details-actions-width', `${this.$refs['actions-column']?.clientWidth}px`);
      }
    },
    async attachResizeObserver() {
      this.resizeObserver = new ResizeObserver(() => {
        this.assignRowDetailsColumnsWidth();
      });
      await this.$nextTick();
      this.resizeObserver.observe(this.$refs.campaigns?.$el);
    },
    getCampaignLinkParams(item) {
      let dataTest;
      let name;

      if (item.state === 'DRAFT') {
        dataTest = 'campaign-details-link';
        name = 'NewCampaign';
      } else if (['LIVE', 'REVIEW', 'PAUSED', 'DORMANT'].includes(item.state)) {
        dataTest = 'campaign-edit-link';
        name = 'EditCampaign';
      } else if (item.state === 'ENDED') {
        dataTest = 'campaign-view-link';
        name = 'ViewCampaign';
      }

      return { dataTest, name };
    },
  },
};
